module.exports = __webpack_public_path__ + "static/img/defaultQrcode_kid.cbaea55f.jpg";